declare namespace $ {

	export class $mol_icon_brain extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=brain.view.tree.d.ts.map